import { Link } from 'react-router-dom';

import { WaitlistForm } from './WaitlistForm';

export const BlogCta = () => (
  <aside className="blog-cta" aria-labelledby="blog-cta-title">
    <p className="eyebrow">Private beta</p>
    <h2 id="blog-cta-title" className="blog-cta__title">
      Measure your real skill
    </h2>
    <p className="blog-cta__copy">
      The first juniors on the waitlist shape the product. Join for free and get your first skill
      check when beta opens. No spam, no recruiters.
    </p>
    <WaitlistForm source="blog" cta="Join the waitlist" hint="Free beta invite. No spam." compact />
    <p className="blog-cta__secondary">
      <Link to="/#waitlist">Or see the full product overview →</Link>
    </p>
  </aside>
);
